import { render } from "./archives.vue?vue&type=template&id=dddb85ca&scoped=true"
import script from "./archives.vue?vue&type=script&lang=js"
export * from "./archives.vue?vue&type=script&lang=js"

import "./archives.vue?vue&type=style&index=0&id=dddb85ca&lang=less&scoped=true"

import exportComponent from "/home/gitlab-runner/builds/NM12r8skh/0/website/official-website-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dddb85ca"]])

export default __exports__